export const COPY = {
  login: {
    title: 'Welcome back to Q-Hub'
  },
  resetPassword: {
    title: 'Forgotten password'
  },
  onboarding: {
    title: 'Welcome to Q-Hub'
  },
  notFound: {
    title: '404 – Page not found'
  },
  permissionsRequired: {
    title: 'You do not have the necessary permissions to access this page'
  },
  setUpPassword: {
    title: 'Welcome to Q-Hub',
    stepOneHeading: 'Set up your password',
    stepTwoHeading: 'Download and sync Authy'
  },
  accountInactive: {
    title: 'Account locked',
    message: 'Your account was locked due to inactivity.',
    unlockAccount: 'To unlock your account, please contact support:',
    email: 'etpmanagers@absa.africa'
  },
  accountLocked: {
    title: 'Your account has been locked',
    message: 'Your account was locked due to too many failed login attempts.',
    unlockAccount: 'Please contact support for more help:',
    email: 'etpmanagers@absa.africa'
  },
  twoFactorNotSetup: {
    title: '2FA not set up',
    message:
      'Please set-up your two-factor authentication using the instructions that were sent to you.'
  },
  twoFactor: {
    unableToLogin: 'Security verification unavailable? Please contact support:',
    email: 'etpmanagers@absa.africa'
  }
}
